// Mock data for Spedy Fly courier landing page clone

export const navLinks = [
  { label: "CHI SIAMO", to: "/chi-siamo" },
  { label: "CONTATTI", to: "/contatti" },
  { label: "HOME", to: "/" },
  { label: "LE NOSTRE SEDI", to: "/sedi" },
];

export const heroContent = {
  title: "Ogni tua spedizione sempre sotto controllo",
  truckImage:
    "https://images.unsplash.com/photo-1547116262-a7365d627e61?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  paragraphs: [
    [
      { text: "Ci occupiamo di offrire ai nostri Clienti le " },
      { text: "migliori soluzioni", bold: true },
      { text: " per Spedire in Italia e Spedire all\u2019estero. Questo facciamo. Niente di pi\u00f9." },
    ],
    [
      { text: "Nessuna distrazione", bold: true },
      { text: ". Ogni giorno facciamo del nostro meglio con " },
      { text: "impegno e dedizione", bold: true },
      { text: " per soddisfare tutte le esigenze di spedizione pacchi dei nostri Clienti." },
    ],
    [
      { text: "Per noi \u00e8 un " },
      { text: "grande traguardo offrire la migliore qualit\u00e0", bold: true },
      { text: " di servizio ed ottenere la " },
      { text: "vostra fiducia", bold: true },
      { text: "." },
    ],
    [
      { text: "Spedite con noi. " },
      { text: "Saremo sempre al vostro fianco", bold: true },
      { text: "." },
    ],
  ],
};

export const couriersContent = {
  title: "Affida a noi la tua spedizione!",
  paragraph:
    "La nostra azienda si affida esclusivamente ai corrieri pi\u00f9 importanti e affidabili del territorio nazionale per garantire spedizioni rapide, sicure e puntuali. Grazie a solide partnership con operatori di primo livello, siamo in grado di offrire un servizio di consegna efficiente e tracciabile, assicurando ai nostri clienti la massima qualit\u00e0 in ogni fase del trasporto. La combinazione tra la nostra organizzazione interna e la professionalit\u00e0 dei migliori corrieri italiani ci permette di gestire ogni spedizione con precisione e totale affidabilit\u00e0.",
  logos: ["GLS", "UPS", "BRT", "DPD", "POSTE", "CRONO", "SKYNET"],
};

export const trackingContent = {
  title: "Rintraccia Spedizione Italia",
  label: "Codice Spedizione",
  prefix: "SF-",
  placeholder: "Digita il codice della spedizione",
  example: "Esempio codice spedizione: SF-12345678",
  button: "Cerca Spedizione",
  paragraphs: [
    [
      { text: "Per noi di " },
      { text: "spedyfly.com", bold: true },
      { text: " \u00e8 fondamentale poter garantire al nostro cliente di " },
      { text: "rintracciare la spedizione", bold: true },
      { text: " in maniera pratica e senza alcuna difficolt\u00e0. Sappiamo bene che, a fronte dei piccoli imprevisti che potrebbero insorgere, \u00e8 pi\u00f9 che comprensibile voler " },
      { text: "rintracciare il pacco", bold: true },
      { text: " atteso. Attraverso il " },
      { text: "tracking della spedizione,", bold: true },
      { text: " potrai quindi rapidamente verificarne la posizione e i tempi di consegna previsti." },
    ],
    [
      { text: "Con noi di " },
      { text: "Spedy Fly", bold: true },
      { text: " cercare la tua spedizione sar\u00e0 facilissimo. " },
      { text: "Traccia il pacco", bold: true },
      { text: " attraverso il codice di spedizione che hai ricevuto, inseriscilo nell\u2019apposita casella di ricerca e " },
      { text: "controlla la spedizione", bold: true },
      { text: " per capire dove si trova il pacco e quando potrebbe arrivare." },
    ],
  ],
  // Mock tracking results by code (without prefix)
  mockResults: {
    "12345678": {
      status: "In transito",
      steps: [
        { label: "Spedizione presa in carico", place: "Milano (MI)", done: true },
        { label: "In transito", place: "Hub Bologna (BO)", done: true },
        { label: "In consegna", place: "Roma (RM)", done: false },
        { label: "Consegnato", place: "Roma (RM)", done: false },
      ],
    },
  },
};

export const servicesContent = {
  title: "I Nostri Servizi",
  items: [
    {
      icon: "truck",
      title: "Servizi di Trasporto e Consegna",
      text: "Offriamo un servizio di trasporto rapido, affidabile e sicuro per garantire che ogni spedizione arrivi a destinazione senza intoppi. Grazie a un\u2019organizzazione efficiente e a mezzi sempre aggiornati, assicuriamo puntualit\u00e0, cura del carico e massima professionalit\u00e0 in ogni fase della consegna.",
    },
    {
      icon: "package",
      title: "Imballaggio Professionale",
      text: "Il nostro servizio di imballaggio garantisce protezione e integrit\u00e0 del prodotto durante ogni tratta. Utilizziamo materiali di alta qualit\u00e0 e tecniche avanzate per assicurare che ogni articolo sia imballato correttamente, riducendo al minimo rischi e danneggiamenti durante il trasporto.",
    },
    {
      icon: "forklift",
      title: "Movimentazione e Gestione Merci",
      text: "Gestiamo con cura e attenzione ogni operazione di movimentazione grazie ad attrezzature adeguate e personale specializzato. Dallo stoccaggio al carico/scarico merci, offriamo un servizio preciso e affidabile pensato per ottimizzare tempi e processi logistici.",
    },
  ],
};

export const footerContent = {
  text: "Copyright 2018-2025 | Powered by Spedy Fly",
};
